import { useMutation } from '@apollo/client';
import { CREATE_REPORT_MUTATION } from '../../';

export function useCreateReportMutation() {
    return useMutation( CREATE_REPORT_MUTATION );
}
